import {CrownFilled} from '@ant-design/icons';
import {Button} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {Routes} from '../../constants/Routes';
import {isOnboardingDone} from '../../utils/SubscriptionHelper';

const UpgradeButton: React.FC<{
  title?: string;
  style?: React.CSSProperties;
}> = ({title, style}) => {
  const navigate = useNavigate();

  const defaultStyle: React.CSSProperties = {
    background: 'linear-gradient(90deg, #FFD700, #FFB800)',
    border: 'none',
    color: '#3a3333ff',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
  };

  const mergedStyle: React.CSSProperties = {...defaultStyle, ...style};

  return (
    <Button
      type="primary"
      icon={<CrownFilled />}
      style={mergedStyle}
      onClick={() => {
        if (isOnboardingDone()) {
          navigate(Routes.PRICING_DETAILS);
        }
      }}
    >
      {title ?? 'Upgrade'}
    </Button>
  );
};

export default UpgradeButton;
